<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";

import {mapState} from "vuex";


export default {
  page: {
    title: "Billing",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    BillingNavigation: () => import('@/router/view/billing/nav'),
  },
  validations: {

  },
  methods: {

  },
  created() {

  },
  data() {
    return {

    }
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex align-items-center justify-content-between p-0">
      <h4 class="mb-0 font-size-18">
        Billing
      </h4>
      <div class="page-title-right bv-d-xs-down-none">
        <ol class="breadcrumb m-0">
        <li class="breadcrumb-item">
          <router-link to="/">
            CFTools Cloud
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <span aria-current="location">
            Billing
          </span>
        </li>
      </ol>
      </div>
    </div>
    <BillingNavigation/>
  </Layout>
</template>